<template>
  <div class="c-pageTitle">
    <div class="c-pageTitle__text">
      {{ titleText }}
    </div>
    <div class="c-pageTitle__asideText" v-if="asideText">
      <div>{{ asideText }}</div>
      <div v-if="asideText2">{{ asideText2 }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleText: String,
    asideText: String,
    asideText2: String,
  },
};
</script>

<style></style>
